import React, { Component } from 'react';

export default class Policy extends Component {
  render() {
    return (
      <div>
        {/* Page Title */}
        <section className="page-title bg-1">
          <div className="overlay"></div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="block text-center">
                  <span className="text-white">Policy</span>
                  <h1 className="text-capitalize mb-5 text-lg">Our Policy</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Content */}
        <section className="section policy-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8" style={{ color: '#555', fontSize: '16px', lineHeight: '1.6' }}>
                <h3>Terms & Conditions</h3>
                <p>Welcome to Varenya Matrimonial. By using our services, you agree to comply with and be bound by the following terms and conditions.</p>
                <ul>
                  <li>All information provided by users must be accurate and truthful.</li>
                  <li>Membership fees are non-refundable.</li>
                  <li>We do not guarantee specific matches or results.</li>
                  <li>Users must respect the privacy and dignity of other members.</li>
                </ul>

                <h3>Privacy Policy</h3>

                <h4>1. Information We Collect</h4>
                <p><strong>a. Personal Information</strong></p>
                <ul>
                  <li>Name, email address, phone number, date of birth</li>
                  <li>Address, gender, marital status (for matrimonial services)</li>
                  <li>Payment details (only if you purchase services)</li>
                </ul>

                <p><strong>b. Usage Data</strong></p>
                <ul>
                  <li>IP address, browser type, pages visited, access times</li>
                  <li>Device type, operating system</li>
                </ul>

                <h4>2. How We Use Your Information</h4>
                <ul>
                  <li>Provide and personalize our Services</li>
                  <li>Create and manage user profiles/accounts</li>
                  <li>Facilitate communication between users (if applicable)</li>
                  <li>Process payments and transactions</li>
                  <li>Send service-related updates, newsletters, or marketing emails (with opt-out options)</li>
                  <li>Monitor usage and improve our platform</li>
                  <li>Ensure legal compliance and prevent fraud</li>
                </ul>

                <h4>3. Sharing of Information</h4>
                <ul>
                  <li>Trusted service providers (hosting, analytics, payment processors)</li>
                  <li>Legal authorities when required by law</li>
                  <li>Other users (if your profile is publicly visible or you initiate contact)</li>
                </ul>
                <p>We do not sell your personal data to third parties.</p>

                <h4>4. Data Retention</h4>
                <p>We retain your data for as long as your account is active or as needed to provide our Services. You may request deletion of your account and associated data by contacting us at <a href="mailto:varenyamatrimonial@gmail.com">varenyamatrimonial@gmail.com</a>.</p>

                <h4>5. Your Rights</h4>
                <ul>
                  <li>Access, update, or delete your personal information</li>
                  <li>Withdraw consent or object to data processing</li>
                  <li>Lodge a complaint with a data protection authority</li>
                </ul>

                <h4>6. Cookies & Tracking</h4>
                <p>Our site uses cookies and similar technologies to:</p>
                <ul>
                  <li>Remember preferences</li>
                  <li>Analyze site traffic</li>
                  <li>Improve user experience</li>
                </ul>
                <p>You can manage cookie preferences through your browser settings.</p>

                <h4>7. Data Security</h4>
                <p>We implement reasonable safeguards to protect your information, but no system is 100% secure. We recommend using strong passwords and logging out after each session.</p>

                <h4>8. Third-Party Links</h4>
                <p>Our Services may contain links to third-party websites. We are not responsible for their privacy practices and encourage you to read their privacy policies.</p>

                <h4>9. Children's Privacy</h4>
                <p>Our Services are not intended for children under the age of 18. We do not knowingly collect data from minors.</p>

                <h3>Contact Us</h3>
                <p>For any questions, please contact: +91 63603 34247 or <a href="mailto:varenyamatrimonial@gmail.com">varenyamatrimonial@gmail.com</a>.</p>
              </div>
            </div>
          </div>
        </section>

      </div>
    );
  }
}
